import { Plan } from '@/shared/types/Billing';

export const excludeArchivedPlans = (plans: Plan[]) => {
  return plans.filter((plan) => !plan.is_archived);
};
